import { render, staticRenderFns } from "./DebtorAdjustmentView.vue?vue&type=template&id=2b841f2c"
import script from "./DebtorAdjustmentView.vue?vue&type=script&lang=js"
export * from "./DebtorAdjustmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b841f2c')) {
      api.createRecord('2b841f2c', component.options)
    } else {
      api.reload('2b841f2c', component.options)
    }
    module.hot.accept("./DebtorAdjustmentView.vue?vue&type=template&id=2b841f2c", function () {
      api.rerender('2b841f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtoradjustment/DebtorAdjustmentView.vue"
export default component.exports